module.exports = __webpack_public_path__ + "static/media/resetpwd.a85aae65.svg";